module.exports = __webpack_public_path__ + "img/62.5829dd9.jpg";